import React from "react";

const ComingSoon = () => (
  <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4">
    <div className="flex flex-col items-center">
      <svg
        className="w-20 h-20 mb-6 text-[#009df2] animate-bounce"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <h1 className="text-5xl font-bold text-white mb-4 text-center">
        Coming Soon
      </h1>
      <p className="text-lg text-gray-300 text-center max-w-xl mb-2">
        We're working hard to bring you this feature. Stay tuned for updates!
      </p>
    </div>
  </div>
);

export default ComingSoon;
